import * as React from "react";
import PropTypes from "prop-types";

import { computeTimeList } from "./time";
import "./time-list-styles.css";
import { TimeType } from "../../model/utils";

const TimeList = ({
  minTime,
  maxTime,
  timeStep,
  allowedTimes,
  columnNumber,
  selectedTime,
  setSelectedTime,
  markOver
}) => {
  return (
    <ul styleName="time-list" className={`col-num-${columnNumber}`}>
      {computeTimeList(minTime, maxTime, timeStep, allowedTimes).map(
        ({ str, enabled }, i) => (
          <li
            key={str}
            styleName={[
              enabled ? "" : "disabled",
              str === selectedTime ? "selected" : "",
              typeof markOver === "number" && i >= markOver
                ? "need-left-border"
                : ""
            ].join(" ")}
            onClick={() => setSelectedTime(str)}
          >
            {str}
          </li>
        )
      )}
    </ul>
  );
};

TimeList.propTypes = {
  minTime: TimeType.isRequired,
  maxTime: TimeType.isRequired,
  timeStep: PropTypes.number.isRequired,
  allowedTimes: PropTypes.arrayOf(TimeType).isRequired,
  columnNumber: PropTypes.number.isRequired,
  selectedTime: PropTypes.string,
  setSelectedTime: PropTypes.func,
  markOver: PropTypes.number
};

export default TimeList;
